<div class="div-coluna-direita-content h-100 d-flex justify-content-center">
    <div class="div-traco"></div>

    <div class="text-content-right">
        <p class="titulo my-3">
            <b>{{ 'shared.authRightColumn.title' | transloco }}</b> <br/>
            {{ 'shared.authRightColumn.tagline' | transloco }}
        </p>
        <p class="subtitulo">
            {{ 'shared.authRightColumn.subtitle' | transloco }}
        </p>
    </div>

    <div class="image-container">
        <img
            src="../../../../assets/img/notebook.png"
            width="100%"
            [attr.alt]="'shared.authRightColumn.title' | transloco"/>
    </div>
</div>

